// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ChannelTextLocalization } from "../schema";

export function serialize_ChannelTextLocalization_internal(value: ChannelTextLocalization): unknown {
  return ((value: { description: string | null; synonym: string | null; title: string | null }): unknown => {
    return {
      description: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["description"]),
      synonym: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["synonym"]),
      title: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["title"]),
    };
  })(value);
}
export function serialize_ChannelTextLocalization(obj: ChannelTextLocalization): string {
  return renderJsonWithNumbersAsBigint(serialize_ChannelTextLocalization_internal(obj));
}
export function deserialize_ChannelTextLocalization_internal(value: unknown): ParserResult<ChannelTextLocalization> {
  return ((
    value: unknown,
  ): ParserResult<{
    description: string | null;
    synonym: string | null;
    title: string | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ChannelTextLocalization]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ChannelTextLocalization]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "description")) {
      return { success: false, reason: `[#/components/schemas/ChannelTextLocalization/description]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'description'.` };
    }
    const parsed_description = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ChannelTextLocalization/description]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["description"]);
    })();
    if (!parsed_description.success) {
      return { success: false, reason: parsed_description.reason };
    }
    if (!hasProp(value, "synonym")) {
      return { success: false, reason: `[#/components/schemas/ChannelTextLocalization/synonym]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'synonym'.` };
    }
    const parsed_synonym = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ChannelTextLocalization/synonym]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["synonym"]);
    })();
    if (!parsed_synonym.success) {
      return { success: false, reason: parsed_synonym.reason };
    }
    if (!hasProp(value, "title")) {
      return { success: false, reason: `[#/components/schemas/ChannelTextLocalization/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
    }
    const parsed_title = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/ChannelTextLocalization/title]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["title"]);
    })();
    if (!parsed_title.success) {
      return { success: false, reason: parsed_title.reason };
    }
    return { success: true, value: { description: parsed_description.value, synonym: parsed_synonym.value, title: parsed_title.value } };
  })(value);
}
export function deserialize_ChannelTextLocalization(str: string): ParserResult<ChannelTextLocalization> {
  return deserialize_ChannelTextLocalization_internal(parseJsonWithNumbersAsBigint(str));
}
